module.exports = __webpack_public_path__ + "static/img/no3.8ee13d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no3.png
// module id = TDjk
// module chunks = 1